import { useMemo } from 'react';
import { getDocumentFields, getItemsByType } from 'utils/helper';

export default ({
  section,
  type,
}) => {
  const {
    title,
    description,
    subtitle,
    contentModules,
    view,
  } = useMemo(() => getDocumentFields(
    section,
    [
      'title',
      'subtitle',
      'description',
      'contentModules',
      'view',
    ],
  ), [section]);

  const [firstBlock] = getItemsByType(
    contentModules,
    'block',
    [
      'images',
      'title',
      'subtitle',
    ],
  );

  const [link] = getItemsByType(
    contentModules,
    'link',
    ['buttonTitle', 'url'],
  );

  return {
    title,
    description,
    images: firstBlock?.images,
    secondSubtitle: firstBlock?.subtitle,
    secondTitle: firstBlock?.title,
    subtitle,
    view,
    type,
    link,
  };
};
